// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tgr-col,
[class*=tgr-col-] {
    grid-column-end: auto;
    margin: 0;
    width: auto;
}

/* MD */
@media screen and (min-width: 768px) {

    .tgr-col-1 {
        grid-column-end: span 1
    }

    .tgr-col-offset-1 {
        grid-column-start: 1
    }

    .tgr-col-2{
        grid-column-end: span 2
    }

    .tgr-col-offset-2 {
        grid-column-start: 2
    }

    .tgr-col-3 {
        grid-column-end: span 3
    }

    .tgr-col-offset-3 {
        grid-column-start: 3
    }

    .tgr-col-4 {
        grid-column-end: span 4
    }

    .tgr-col-offset-4 {
        grid-column-start: 4
    }

    .tgr-col-5 {
        grid-column-end: span 5
    }

    .tgr-col-offset-5 {
        grid-column-start: 5
    }

    .tgr-col-6 {
        grid-column-end: span 6
    }

    .tgr-col-offset-6 {
        grid-column-start: 6
    }

    .tgr-col-7 {
        grid-column-end: span 7
    }

    .tgr-col-offset-7 {
        grid-column-start: 7
    }

    .tgr-col-8 {
        grid-column-end: span 8
    }

    .tgr-col-offset-8 {
        grid-column-start: 8
    }

    .tgr-col-9 {
        grid-column-end: span 9
    }

    .tgr-col-offset-9 {
        grid-column-start: 9
    }

    .tgr-col-10 {
        grid-column-end: span 10
    }

    .tgr-col-offset-10 {
        grid-column-start: 10
    }

    .tgr-col-11 {
        grid-column-end: span 11
    }

    .tgr-col-offset-11 {
        grid-column-start: 11
    }

    .tgr-col-12 {
        grid-column-end: span 12
    }

    .tgr-col-offset-12 {
        grid-column-start: 12
    }

    .tgr-col-md-1 {
        grid-column-end: span 1
    }
    .tgr-col-offset-md-1{
        grid-column-start: 1
    }
    .tgr-col-md-2 {
        grid-column-end: span 2
    }
    .tgr-col-offset-md-2 {
        grid-column-start: 2
    }
    .tgr-col-md-3 {
        grid-column-end: span 3
    }
    .tgr-col-offset-md-3 {
        grid-column-start: 3
    }
    .tgr-col-md-4 {
        grid-column-end: span 4
    }
    .tgr-col-offset-md-4 {
        grid-column-start: 4
    }
    .tgr-col-md-5 {
        grid-column-end: span 5
    }
    .tgr-col-offset-md-5 {
        grid-column-start: 5
    }
    .tgr-col-md-6 {
        grid-column-end: span 6
    }
    .tgr-col-offset-md-6 {
        grid-column-start: 6
    }
    .tgr-col-md-7 {
        grid-column-end: span 7
    }
    .tgr-col-offset-md-7 {
        grid-column-start: 7
    }
    .tgr-col-md-8 {
        grid-column-end: span 8
    }
    .tgr-col-offset-md-8 {
        grid-column-start: 8
    }
    .tgr-col-md-9 {
        grid-column-end: span 9
    }
    .tgr-col-offset-md-9 {
        grid-column-start: 9
    }
    .tgr-col-md-10 {
        grid-column-end: span 10
    }
    .tgr-col-offset-md-10 {
        grid-column-start: 10
    }
    .tgr-col-md-11 {
        grid-column-end: span 11
    }
    .tgr-col-offset-md-11 {
        grid-column-start: 11
    }
    .tgr-col-md-12 {
        grid-column-end: span 12
    }
    .tgr-col-offset-md-12 {
        grid-column-start: 12
    }
}

/* LG */
@media screen and (min-width: 1024px) {
    .tgr-col-lg-1 {
        grid-column-end: span 1
    }
    .tgr-col-offset-lg-1{
        grid-column-start: 1
    }
    .tgr-col-lg-2 {
        grid-column-end: span 2
    }
    .tgr-col-offset-lg-2 {
        grid-column-start: 2
    }
    .tgr-col-lg-3 {
        grid-column-end: span 3
    }
    .tgr-col-offset-lg-3 {
        grid-column-start: 3
    }
    .tgr-col-lg-4 {
        grid-column-end: span 4
    }
    .tgr-col-offset-lg-4 {
        grid-column-start: 4
    }
    .tgr-col-lg-5 {
        grid-column-end: span 5
    }
    .tgr-col-offset-lg-5 {
        grid-column-start: 5
    }
    .tgr-col-lg-6 {
        grid-column-end: span 6
    }
    .tgr-col-offset-lg-6 {
        grid-column-start: 6
    }
    .tgr-col-lg-7 {
        grid-column-end: span 7
    }
    .tgr-col-offset-lg-7 {
        grid-column-start: 7
    }
    .tgr-col-lg-8 {
        grid-column-end: span 8
    }
    .tgr-col-offset-lg-8 {
        grid-column-start: 8
    }
    .tgr-col-lg-9 {
        grid-column-end: span 9
    }
    .tgr-col-offset-lg-9 {
        grid-column-start: 9
    }
    .tgr-col-lg-10 {
        grid-column-end: span 10
    }
    .tgr-col-offset-lg-10 {
        grid-column-start: 10
    }
    .tgr-col-lg-11 {
        grid-column-end: span 11
    }
    .tgr-col-offset-lg-11 {
        grid-column-start: 11
    }
    .tgr-col-lg-12 {
        grid-column-end: span 12
    }
    .tgr-col-offset-lg-12 {
        grid-column-start: 12
    }
}



/* XL */
@media screen and (min-width: 1044px) {
    .tgr-col-xl-1 {
        grid-column-end: span 1
    }
    .tgr-col-offset-xl-1{
        grid-column-start: 1
    }
    .tgr-col-xl-2 {
        grid-column-end: span 2
    }
    .tgr-col-offset-xl-2 {
        grid-column-start: 2
    }
    .tgr-col-xl-3 {
        grid-column-end: span 3
    }
    .tgr-col-offset-xl-3 {
        grid-column-start: 3
    }
    .tgr-col-xl-4 {
        grid-column-end: span 4
    }
    .tgr-col-offset-xl-4 {
        grid-column-start: 4
    }
    .tgr-col-xl-5 {
        grid-column-end: span 5
    }
    .tgr-col-offset-xl-5 {
        grid-column-start: 5
    }
    .tgr-col-xl-6 {
        grid-column-end: span 6
    }
    .tgr-col-offset-xl-6 {
        grid-column-start: 6
    }
    .tgr-col-xl-7 {
        grid-column-end: span 7
    }
    .tgr-col-offset-xl-7 {
        grid-column-start: 7
    }
    .tgr-col-xl-8 {
        grid-column-end: span 8
    }
    .tgr-col-offset-xl-8 {
        grid-column-start: 8
    }
    .tgr-col-xl-9 {
        grid-column-end: span 9
    }
    .tgr-col-offset-xl-9 {
        grid-column-start: 9
    }
    .tgr-col-xl-10 {
        grid-column-end: span 10
    }
    .tgr-col-offset-xl-10 {
        grid-column-start: 10
    }
    .tgr-col-xl-11 {
        grid-column-end: span 11
    }
    .tgr-col-offset-xl-11 {
        grid-column-start: 11
    }
    .tgr-col-xl-12 {
        grid-column-end: span 12
    }
    .tgr-col-offset-xl-12 {
        grid-column-start: 12
    }
}`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-web-core/dist/grid/cols.css"],"names":[],"mappings":"AAAA;;IAEI,qBAAqB;IACrB,SAAS;IACT,WAAW;AACf;;AAEA,OAAO;AACP;;IAEI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA,OAAO;AACP;IACI;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;;;;AAIA,OAAO;AACP;IACI;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ","sourcesContent":[".tgr-col,\n[class*=tgr-col-] {\n    grid-column-end: auto;\n    margin: 0;\n    width: auto;\n}\n\n/* MD */\n@media screen and (min-width: 768px) {\n\n    .tgr-col-1 {\n        grid-column-end: span 1\n    }\n\n    .tgr-col-offset-1 {\n        grid-column-start: 1\n    }\n\n    .tgr-col-2{\n        grid-column-end: span 2\n    }\n\n    .tgr-col-offset-2 {\n        grid-column-start: 2\n    }\n\n    .tgr-col-3 {\n        grid-column-end: span 3\n    }\n\n    .tgr-col-offset-3 {\n        grid-column-start: 3\n    }\n\n    .tgr-col-4 {\n        grid-column-end: span 4\n    }\n\n    .tgr-col-offset-4 {\n        grid-column-start: 4\n    }\n\n    .tgr-col-5 {\n        grid-column-end: span 5\n    }\n\n    .tgr-col-offset-5 {\n        grid-column-start: 5\n    }\n\n    .tgr-col-6 {\n        grid-column-end: span 6\n    }\n\n    .tgr-col-offset-6 {\n        grid-column-start: 6\n    }\n\n    .tgr-col-7 {\n        grid-column-end: span 7\n    }\n\n    .tgr-col-offset-7 {\n        grid-column-start: 7\n    }\n\n    .tgr-col-8 {\n        grid-column-end: span 8\n    }\n\n    .tgr-col-offset-8 {\n        grid-column-start: 8\n    }\n\n    .tgr-col-9 {\n        grid-column-end: span 9\n    }\n\n    .tgr-col-offset-9 {\n        grid-column-start: 9\n    }\n\n    .tgr-col-10 {\n        grid-column-end: span 10\n    }\n\n    .tgr-col-offset-10 {\n        grid-column-start: 10\n    }\n\n    .tgr-col-11 {\n        grid-column-end: span 11\n    }\n\n    .tgr-col-offset-11 {\n        grid-column-start: 11\n    }\n\n    .tgr-col-12 {\n        grid-column-end: span 12\n    }\n\n    .tgr-col-offset-12 {\n        grid-column-start: 12\n    }\n\n    .tgr-col-md-1 {\n        grid-column-end: span 1\n    }\n    .tgr-col-offset-md-1{\n        grid-column-start: 1\n    }\n    .tgr-col-md-2 {\n        grid-column-end: span 2\n    }\n    .tgr-col-offset-md-2 {\n        grid-column-start: 2\n    }\n    .tgr-col-md-3 {\n        grid-column-end: span 3\n    }\n    .tgr-col-offset-md-3 {\n        grid-column-start: 3\n    }\n    .tgr-col-md-4 {\n        grid-column-end: span 4\n    }\n    .tgr-col-offset-md-4 {\n        grid-column-start: 4\n    }\n    .tgr-col-md-5 {\n        grid-column-end: span 5\n    }\n    .tgr-col-offset-md-5 {\n        grid-column-start: 5\n    }\n    .tgr-col-md-6 {\n        grid-column-end: span 6\n    }\n    .tgr-col-offset-md-6 {\n        grid-column-start: 6\n    }\n    .tgr-col-md-7 {\n        grid-column-end: span 7\n    }\n    .tgr-col-offset-md-7 {\n        grid-column-start: 7\n    }\n    .tgr-col-md-8 {\n        grid-column-end: span 8\n    }\n    .tgr-col-offset-md-8 {\n        grid-column-start: 8\n    }\n    .tgr-col-md-9 {\n        grid-column-end: span 9\n    }\n    .tgr-col-offset-md-9 {\n        grid-column-start: 9\n    }\n    .tgr-col-md-10 {\n        grid-column-end: span 10\n    }\n    .tgr-col-offset-md-10 {\n        grid-column-start: 10\n    }\n    .tgr-col-md-11 {\n        grid-column-end: span 11\n    }\n    .tgr-col-offset-md-11 {\n        grid-column-start: 11\n    }\n    .tgr-col-md-12 {\n        grid-column-end: span 12\n    }\n    .tgr-col-offset-md-12 {\n        grid-column-start: 12\n    }\n}\n\n/* LG */\n@media screen and (min-width: 1024px) {\n    .tgr-col-lg-1 {\n        grid-column-end: span 1\n    }\n    .tgr-col-offset-lg-1{\n        grid-column-start: 1\n    }\n    .tgr-col-lg-2 {\n        grid-column-end: span 2\n    }\n    .tgr-col-offset-lg-2 {\n        grid-column-start: 2\n    }\n    .tgr-col-lg-3 {\n        grid-column-end: span 3\n    }\n    .tgr-col-offset-lg-3 {\n        grid-column-start: 3\n    }\n    .tgr-col-lg-4 {\n        grid-column-end: span 4\n    }\n    .tgr-col-offset-lg-4 {\n        grid-column-start: 4\n    }\n    .tgr-col-lg-5 {\n        grid-column-end: span 5\n    }\n    .tgr-col-offset-lg-5 {\n        grid-column-start: 5\n    }\n    .tgr-col-lg-6 {\n        grid-column-end: span 6\n    }\n    .tgr-col-offset-lg-6 {\n        grid-column-start: 6\n    }\n    .tgr-col-lg-7 {\n        grid-column-end: span 7\n    }\n    .tgr-col-offset-lg-7 {\n        grid-column-start: 7\n    }\n    .tgr-col-lg-8 {\n        grid-column-end: span 8\n    }\n    .tgr-col-offset-lg-8 {\n        grid-column-start: 8\n    }\n    .tgr-col-lg-9 {\n        grid-column-end: span 9\n    }\n    .tgr-col-offset-lg-9 {\n        grid-column-start: 9\n    }\n    .tgr-col-lg-10 {\n        grid-column-end: span 10\n    }\n    .tgr-col-offset-lg-10 {\n        grid-column-start: 10\n    }\n    .tgr-col-lg-11 {\n        grid-column-end: span 11\n    }\n    .tgr-col-offset-lg-11 {\n        grid-column-start: 11\n    }\n    .tgr-col-lg-12 {\n        grid-column-end: span 12\n    }\n    .tgr-col-offset-lg-12 {\n        grid-column-start: 12\n    }\n}\n\n\n\n/* XL */\n@media screen and (min-width: 1044px) {\n    .tgr-col-xl-1 {\n        grid-column-end: span 1\n    }\n    .tgr-col-offset-xl-1{\n        grid-column-start: 1\n    }\n    .tgr-col-xl-2 {\n        grid-column-end: span 2\n    }\n    .tgr-col-offset-xl-2 {\n        grid-column-start: 2\n    }\n    .tgr-col-xl-3 {\n        grid-column-end: span 3\n    }\n    .tgr-col-offset-xl-3 {\n        grid-column-start: 3\n    }\n    .tgr-col-xl-4 {\n        grid-column-end: span 4\n    }\n    .tgr-col-offset-xl-4 {\n        grid-column-start: 4\n    }\n    .tgr-col-xl-5 {\n        grid-column-end: span 5\n    }\n    .tgr-col-offset-xl-5 {\n        grid-column-start: 5\n    }\n    .tgr-col-xl-6 {\n        grid-column-end: span 6\n    }\n    .tgr-col-offset-xl-6 {\n        grid-column-start: 6\n    }\n    .tgr-col-xl-7 {\n        grid-column-end: span 7\n    }\n    .tgr-col-offset-xl-7 {\n        grid-column-start: 7\n    }\n    .tgr-col-xl-8 {\n        grid-column-end: span 8\n    }\n    .tgr-col-offset-xl-8 {\n        grid-column-start: 8\n    }\n    .tgr-col-xl-9 {\n        grid-column-end: span 9\n    }\n    .tgr-col-offset-xl-9 {\n        grid-column-start: 9\n    }\n    .tgr-col-xl-10 {\n        grid-column-end: span 10\n    }\n    .tgr-col-offset-xl-10 {\n        grid-column-start: 10\n    }\n    .tgr-col-xl-11 {\n        grid-column-end: span 11\n    }\n    .tgr-col-offset-xl-11 {\n        grid-column-start: 11\n    }\n    .tgr-col-xl-12 {\n        grid-column-end: span 12\n    }\n    .tgr-col-offset-xl-12 {\n        grid-column-start: 12\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
